import state from './intervalState'

const disconnectNotifications = () => {
  clearInterval(state.interval)
  state.interval = null
  // Drop the key written by previous builds
  localStorage.removeItem('notifications_interval')
}

export default disconnectNotifications



// WEBPACK FOOTER //
// ./src/services/notification/disconnectNotifications.js